import { Text, Toggle, colors } from '@khaddi/ui';
import { ActivityIndicator, View } from 'react-native';

/** The translucent pill in the navy header; the whole pill is a 44 px target via the inner switch. */
export const OnlineToggle = ({ online, pending, onChange }: { online: boolean; pending: boolean; onChange: (online: boolean) => void }) => (
  <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, backgroundColor: 'rgba(255,255,255,.55)', borderRadius: 22, height: 44, paddingLeft: 10, paddingRight: 6 }}>
    {pending ? <ActivityIndicator size="small" color={colors.text} /> : <View style={{ width: 8, height: 8, borderRadius: 4, backgroundColor: online ? colors.mint : colors.textSubtle }} />}
    <Text variant="bodyStrong" color={colors.text} style={{ fontSize: 13 }}>
      {online ? 'Đang nhận đơn' : 'Đang nghỉ'}
    </Text>
    <Toggle value={online} onChange={onChange} label="Nhận đơn mới" activeColor={colors.mint} />
  </View>
);
